import { EventsQrCodeModule } from './events/events-qrcode/events-qrcode.module';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ResultsResolver } from './results/results-home/results-resolver/results.resolver';
import { LoginGuard } from './guards/login-guard/login.guard';
import { UserGuard } from './guards/user-guard/user.guard';
import { SessionRedirectGuard } from './sessions/sessionsRedirectGuard';
import { OAuthCallbackComponent } from './login/oauth-callback/oauth-callback.component';

const routes: Routes = [{
  path: 'home',
  loadChildren: (() =>
    import('./home/home.module').then((m) => m.HomeModule))
}, {
  path: 'home/:style',
  loadChildren: (() =>
    import('./home/home.module').then((m) => m.HomeModule))
}, {
  path: 'events',
  loadChildren: (() =>
    import('./events/events.module').then((m) => m.EventsModule))
},{
  path: 'events/:enaorig',
  loadChildren: (() =>
    import('./events/events.module').then((m) => m.EventsModule))
},{
  path: 'events/:enaorig/:lang',
  loadChildren: (() =>
    import('./events/events.module').then((m) => m.EventsModule))
},{
  path: 'events/:layer/:enaorig/:style',
  loadChildren: (() =>
    import('./events/events.module').then((m) => m.EventsModule))
}, {
  path: 'results',
  loadChildren: (() =>
    import('./results/results.module').then((m) => m.ResultsModule)),
    resolve: { resolved: ResultsResolver }
},{
  path: 'results/details/:resultId/:cid',
  loadChildren: (() =>
    import('./results/results-details/results-details.module').then((m) => m.ResultsDetailsModule))
},{
  path: 'results/details/:resultId/:cid/:style',
  loadChildren: (() =>
    import('./results/results-details/results-details.module').then((m) => m.ResultsDetailsModule))
},{
  path: 'results/details/:resultId/:cid/:lang/:style',
  loadChildren: (() =>
    import('./results/results-details/results-details.module').then((m) => m.ResultsDetailsModule))
},{
  path: 'lineup',
  loadChildren: (() =>
    import('./lineup/lineup.module').then((m) => m.LineupModule))
},{
  path: 'schedule',
  loadChildren: (() =>
    import('./schedule/schedule.module').then((m) => m.ScheduleModule))
}, {
  path: 'news',
  loadChildren: (() =>
    import('./news/news.module').then((m) => m.NewsModule))
},{
  path: 'gallery',
  loadChildren: (() =>
    import('./pages/gallery/gallery.module').then((m) => m.GalleryModule))
},{
  path: 'shop',
  loadChildren: (() =>
    import('./pages/shop/shop-main/shop.module').then((m) => m.ShopModule))
},{
  path: 'cart',
  loadChildren: (() =>
    import('./pages/shop/shop-cart/shop-cart.module').then((m) => m.ShopCartModule))
},
 {
  path: 'sessions',
  canActivate: [SessionRedirectGuard],
  loadChildren: (() =>
    import('./sessions/sessions.module').then((m) => m.SessionsModule))
}, {
  path: 'sessions/:sessionId',
  loadChildren: (() =>
    import('./sessions/sessions.module').then((m) => m.SessionsModule))
}, {
  path: 'webpage',
  loadChildren: (() =>
    import('./webpage/webpage.module').then((m) => m.WebpageComponentModule))
},{
  path: 'product/:index',
  loadChildren: (() =>
    import('./pages/shop/shop-product-details/shop-product-details.module').then((m) => m.ShopProductDetailsModule))
}, {
  path: 'user',
  canActivate: [UserGuard],
  loadChildren: (() =>
    import('./user/user.module').then((m) => m.UserModule))
}, {
  path: 'contact',
  loadChildren: (() =>
    import('./contact/contact.module').then((m) => m.ContactModule))
},{
  path: 'qrcode/:eventId',
  loadChildren: (() =>
    import('./events/events-qrcode/events-qrcode.module').then((m) => m.EventsQrCodeModule))
},{
  path: 'qrcode/:eventId/:style',
  loadChildren: (() =>
    import('./events/events-qrcode/events-qrcode.module').then((m) => m.EventsQrCodeModule))
}, {
  path: 'event/details/:eventId',
  loadChildren: (() =>
    import('./events/events-details/events-details.module').then((m) => m.EventsDetailsModule))
},{
  path: 'event/details/:eventId/:style',
  loadChildren: (() =>
    import('./events/events-details/events-details.module').then((m) => m.EventsDetailsModule))
},{
  path: 'event/details/:eventId/:lang/:style',
  loadChildren: (() =>
    import('./events/events-details/events-details.module').then((m) => m.EventsDetailsModule))
},{
  path: 'event/map/:eventId',
  loadChildren: (() =>
    import('./events/events-map/events-map.module').then((m) => m.EventsMapModule))
},{
  path: 'event/map/:eventId/:style',
  loadChildren: (() =>
    import('./events/events-map/events-map.module').then((m) => m.EventsMapModule))
},{
  path: 'event/map/:eventId/:lang/:style',
  loadChildren: (() =>
    import('./events/events-map/events-map.module').then((m) => m.EventsMapModule))
}, {
  path: 'login',
  loadChildren: (() =>
    import('./login/login.module').then((m) => m.LoginModule))
}, {
  path: 'login/:return',
  loadChildren: (() =>
    import('./login/login.module').then((m) => m.LoginModule))
}, {
  path: 'register',
  loadChildren: (() =>
    import('./registration/registration.module').then((m) => m.RegistrationModule))
}, {
  path: 'news/news-details/:postId',
  loadChildren: (() =>
    import('./news/news-details/news-details.module').then((m) => m.NewsDetailsModule))
},{
  path: 'checkout',
  loadChildren: (() =>
    import('./pages/payment/payment-page.module').then((m) => m.PaymentPageModule))
},{
  path: 'payment/:eventId',
  canActivate: [LoginGuard],
  loadChildren: (() =>
    import('./pages/payment/payment-page.module').then((m) => m.PaymentPageModule))
},{
  path: 'payment/:eventId/:style',
  canActivate: [LoginGuard],
  loadChildren: (() =>
    import('./pages/payment/payment-page.module').then((m) => m.PaymentPageModule))
},{
  path: 'code',
  loadChildren: (() =>
    import('./pages/shop/shop-qrcode/shop-qrcode.module').then((m) => m.ShopQrCodeModule))
},{
  path: 'tickets',
  loadChildren: (() =>
    import('./tickets/tickets-home/tickets.module').then((m) => m.TicketsModule))
},{
  path: 'ticket/details',
  loadChildren: (() =>
    import('./tickets/tickets-details/tickets-details.module').then((m) => m.TicketsDetailsModule))
}, 
{
  path: 'sofort/:evId/:token',
  loadChildren: (() =>
    import('./pages/sofort-instant-payment/sofort-payment.module').then((m) => m.SofortPaymentModule))
},
{
  path: 'paypal/:evId/:token',
  loadChildren: (() =>
    import('./pages/paypal-instant-payment/paypal-payment.module').then((m) => m.PaypalPaymentModule))
},
{
  path: 'giropay/:evId/:token',
  loadChildren: (() =>
    import('./pages/giropay-instant-payment/giropay-payment.module').then((m) => m.GiropayPaymentModule))
},
{
  path: 'giropay/:evId/:token',
  loadChildren: (() =>
    import('./pages/giropay-instant-payment/giropay-payment.module').then((m) => m.GiropayPaymentModule))
},
{
  path: '',
  loadChildren: (() =>
    import('./events/events.module').then((m) => m.EventsModule))
},
{
  path:'oauth/callback',
  component: OAuthCallbackComponent
}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
